(function () {
  if (document.body.classList.contains("page-template-page-start")) return;

  function now() {
    return Date.now();
  }
  function serverNow() {
    return firebase.database.ServerValue.TIMESTAMP;
  }

  firebase
    .auth()
    .signInAnonymously()
    .catch(function (error) {
      const errorCode = error.code;
      const errorMessage = error.message;
      console.error("firebase authentication error", errorCode, errorMessage);

      const errorData = {
        action: "firebase_auth_errors",
        errorCode: errorCode,
        errorMessage: errorMessage,
        userId: WP.uid ? WP.uid : null,
        userNiceName: WP.uid ? WP.niceName : "anonymous",
        time: Date.now(),
        event: window.location.pathname,
      };
      logAuthError(errorData);
    });

  firebase.auth().onAuthStateChanged(function (user) {
    if (user) {
      // * authenticated, go about your business
      const database = firebase.database(),
        envKey = WP.envKey,
        envRef = database.ref(`${envKey}`),
        uid = parseInt(WP.uid) ? WP.uid : null;

      // Presence
      const connectedRef = database.ref(".info/connected");

      connectedRef.on("value", (snap) => {
        if (snap.val() === true) {
          // connected or re-connected
          const visit = envRef
            .child(`userVisits/${uid}`)
            .push({ startAt: now() });

          // every connection ends eventually 💔
          visit.onDisconnect().update({ endAt: serverNow() });
        }
      });
    }
  });

  function logAuthError(data) {
    // AJAX post request
    let formData = new FormData();
    formData.append("action", data.action);
    formData.append("errorCode", data.errorCode);
    formData.append("errorMessage", data.errorMessage);
    formData.append("userId", data.userId);
    formData.append("userNiceName", data.userNiceName);
    formData.append("time", data.time);
    formData.append("event", data.event);

    fetch(WP.ajax_url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams(formData),
    }).then((response) => {
      return response.json();
    });
  }
})();
